import type { CoerceToRecordParams } from '../types';

const coerceToRecord = ({ value }: CoerceToRecordParams): Record<string, unknown> => {
    if (typeof value === 'string') {
        try {
            const parsedValue = JSON.parse(value);
            if (parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue)) {
                return parsedValue as Record<string, unknown>;
            }
        } catch {
            return {};
        }
    }

    if (value && typeof value === 'object' && !Array.isArray(value)) {
        return value as Record<string, unknown>;
    }

    return {};
};

export default coerceToRecord;
